import { Component, Input, ViewChild } from '@angular/core';
import { BaseModalComponent } from 'projects/libraries/syslink-components/src/lib/modal/base-modal/base-modal.component';
import { SaleOrderHeaderStatus } from '../../sale-order-header-statuses/sale-order-header-status.model';
import { SelectComponent } from 'projects/libraries/syslink-components/src/public-api';
import { FilterDescriptor } from 'devextreme/data';
import { SaleOrderHeaderStatusesService } from '../../sale-order-header-statuses/sale-order-header-statuses.service';

@Component({
  selector: 'app-sale-order-status-select-modal',
  templateUrl: './sale-order-status-select-modal.component.html',
  styleUrls: ['./sale-order-status-select-modal.component.scss']
})
export class SaleOrderStatusSelectModalComponent extends BaseModalComponent<SaleOrderHeaderStatus>{
  @Input() public selectFilters: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public expand: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public title: string = "Select order status";
  @Input() public content?: string;
  @Input() public data: any;
  @ViewChild('select') select?: SelectComponent;

  constructor(public saleOrderHeaderStatusesService: SaleOrderHeaderStatusesService) {
    super();
  }

}